module.exports = __webpack_public_path__ + "img/Image2@2x.17b2fe3e.png";